<dx-scroll-view height="100%" [useNative]="false" [showScrollbar]="'always'">
  <ag-shr-excursions-info-table
    *var="
      Entity.conferenceAttendeeDetails | hasPermission: EntityPermissionActivityKeys.write | async as writePermission
    "
    [selectedExcursionsDataSource]="mainEventSelectedExcursionsDataSourceSig()"
    [excursionStatisticsMap]="excursionStatisticsMapSig()"
    [excursionsBudget]="mainEventExcursionsBudgetSig()"
    [isEditable]="true"
    [canEdit]="writePermission"
    [conferenceExcursions]="mainEventExcursionsSig()"
    [sourceType]="sourceType"
  >
    <div class="d-flex" *ngIf="writePermission">
      <div
        *var="excursionsTaskStatus$ | async as excursionsTaskStatus"
        class="d-flex flex-row align-items-center gap-2"
      >
        Owner:
        <ag-shr-assign-owner-viewer
          [owner]="{
            assignedTo: excursionsTaskStatus?.assignedTo ?? null,
            assignedToNote: '',
          }"
          [assignOwnerList]="assignOwnerList$ | async"
          [onOwnerChange]="onOwnerChange"
        ></ag-shr-assign-owner-viewer>
      </div>
      <div
        *var="excursionsTaskStatus$ | async as excursionsTaskStatus"
        class="d-flex flex-row align-items-center gap-2"
      >
        Status:

        <dx-select-box
          [value]="excursionsTaskStatus?.status"
          (onValueChanged)="onTaskStatusChanged(excursionsTaskStatus?.status, $event)"
          [dataSource]="taskStatus"
          valueExpr="value"
          displayExpr="description"
        ></dx-select-box>
      </div>
    </div>
  </ag-shr-excursions-info-table>

  @if (isAcceptedChairmanExtensionSig()) {
    <ag-shr-excursions-info-table
      *var="
        Entity.conferenceAttendeeDetails | hasPermission: EntityPermissionActivityKeys.write | async as writePermission
      "
      [selectedExcursionsDataSource]="chairmanExtSelectedExcursionsDataSourceSig()"
      [excursionStatisticsMap]="excursionStatisticsMapSig()"
      [excursionsBudget]="chairmanExtExcursionsBudgetSig()"
      [isEditable]="true"
      [canEdit]="writePermission"
      [conferenceExcursions]="chairmanExtExcursionsSig()"
      [sourceType]="sourceType"
      [registrantSelectedExcursionsKey]="CHAIRMAN_EXT_REGISTRANT_SELECTED_EXCURSIONS_KEY"
      [guestSelectedExcursionsKey]="CHAIRMAN_EXT_GUEST_SELECTED_EXCURSIONS_KEY"
    >
    </ag-shr-excursions-info-table>
  }
</dx-scroll-view>
